import React from 'react'

const Visibility = () => {
    return (
        <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.2497 7.00274C11.2497 8.43839 10.0233 9.59851 8.50571 9.59851C6.98807 9.59851 5.76172 8.43839 5.76172 7.00274C5.76172 5.56709 6.98807 4.40698 8.50571 4.40698C10.0233 4.40698 11.2497 5.56709 11.2497 7.00274Z" stroke="#111AE9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.49998 13C11.2057 13 13.7274 11.4918 15.4826 8.88157C16.1725 7.85921 16.1725 6.14078 15.4826 5.11843C13.7274 2.50816 11.2057 1 8.49998 1C5.79434 1 3.27262 2.50816 1.51737 5.11843C0.827542 6.14078 0.827542 7.85921 1.51737 8.88157C3.27262 11.4918 5.79434 13 8.49998 13Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default Visibility